import React from "react";
import ReactMarkdown from "react-markdown";
import rehypeHighlight from "rehype-highlight";
import rehypeExternalLinks from "rehype-external-links";
import type { Options } from "react-markdown";

type Props = Omit<Options, "children"> & {
  text?: string;
  children?: string;
};

const EXTERNAL_LINK_TARGET = "_blank";

const rehypePlugins: Options["rehypePlugins"] = [
  rehypeHighlight,
  [rehypeExternalLinks, { target: EXTERNAL_LINK_TARGET }],
];

const Markdown = ({
  text = undefined,
  children = "",
  ...extraProps
}: Props): JSX.Element => {
  const content = text || children;

  return (
    <ReactMarkdown
      rehypePlugins={rehypePlugins}
      {...extraProps}
    >
      {content}
    </ReactMarkdown>
  );
};

export default Markdown;
